import LoginScreen from './LoginScreen';
import Onboarding from './Onboarding';
import { useState } from 'react';
import RegisterTransition from './Onboarding/animations/RegisterTransition';

const Landing = () => {
  const [userId, setUserId] = useState<number | null>(null);
  const [activeOnboardingStep, setActiveOnboardingStep] = useState<
    number | undefined
  >();
  const [registering, setRegistering] = useState(false);

  const handleOnboardingInProgress = (
    userId: number,
    onboardingStep: number,
  ) => {
    setUserId(userId);
    setActiveOnboardingStep(onboardingStep);
    setRegistering(true);
  };

  // Login-resume maps the backend onboardingStep (2…5) to a step (1…4).
  const resumeStep =
    activeOnboardingStep != null
      ? Math.min(Math.max(activeOnboardingStep - 1, 0), 4)
      : 0;

  return (
    <div style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <RegisterTransition
        registering={registering}
        login={
          <LoginScreen
            handleOnboardingStart={() => setRegistering(true)}
            handleOnboardingInProgress={handleOnboardingInProgress}
          />
        }
        onboarding={
          <Onboarding
            onBackToLogin={() => setRegistering(false)}
            initialUserId={userId}
            initialStep={resumeStep}
          />
        }
      />
    </div>
  );
};

export default Landing;
